// Shared helpers for the Physical Files section.

export const STATUS_LABEL = {
  active: 'Active',
  archived: 'Archived',
  handed_over: 'Handed over',
};

export const STATUS_VARIANT = {
  active: 'success',
  archived: 'neutral',
  handed_over: 'info',
};

export const STATUS_OPTIONS = [
  { value: 'active', label: 'Active' },
  { value: 'archived', label: 'Archived' },
  { value: 'handed_over', label: 'Handed over' },
];

export const STATUS_FILTERS = [{ value: '', label: 'All statuses' }, ...STATUS_OPTIONS];

export const fmtDate = (d) =>
  d ? new Date(d).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' }) : '—';
